import generateColorScale from "./generateColorScale";
import generateTitle from "./generateTitle";

export { generateColorScale, generateTitle };
